'use client';

import { useState, type MouseEvent } from 'react';
import { IconButton } from '@/features/uiKit/IconButton';
import { PauseIcon, PlayArrowIcon } from '@/features/uiKit/icons';

interface HeroPauseButtonProps {
  pauseLabel: string;
  playLabel: string;
}

export const HeroPauseButton = ({ pauseLabel, playLabel }: HeroPauseButtonProps) => {
  const [isPaused, setIsPaused] = useState(false);

  const toggle = (event: MouseEvent<HTMLElement>) => {
    const root = event.currentTarget.closest('[data-hero-root]');
    const nextPaused = !isPaused;
    root?.toggleAttribute('data-paused', nextPaused);
    setIsPaused(nextPaused);
  };

  return (
    <IconButton
      tone="plain"
      size="small"
      aria-label={isPaused ? playLabel : pauseLabel}
      title={isPaused ? playLabel : pauseLabel}
      onClick={toggle}
    >
      {isPaused ? <PlayArrowIcon fontSize={18} /> : <PauseIcon fontSize={18} />}
    </IconButton>
  );
};
